<template>
  <div class="container">
    <div class="search_box">
      <v-search :searchType="'carTechnology'" :limit="tableParams.limit" @searchParams="searchChange($event)"></v-search>
    </div>
    <div class="table_box">
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column property="number" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="carNumber" label="车牌号码">
        </el-table-column>
        <el-table-column property="carColorStr" label="车牌颜色">
        </el-table-column>
        <el-table-column property="carServiceStr" label="车辆营运性质">
        </el-table-column>
        <el-table-column property="technicalGradeTime" label="技术等级有效期" sortable>
        </el-table-column>
        <el-table-column property="nextMaintainTime" label="建议下次维养时间" sortable>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <v-redact :dialogShow.sync="redactShow" :dialogData="redactData"></v-redact>
    <v-detail :dialogData="detailData" :dialogShow.sync="detailShow"></v-detail>
  </div>
</template>

<script>
import search from "@/components/search.vue";
import redact from "./carTechnology_component/redact.vue";
import detail from "./carTechnology_component/detail/detail.vue";
import { exportExcel } from "@/utils/util";
export default {
  name: "carTechnology",
  data () {
    return {
      tableData: [],
      addStaffShow: false,
      redactShow: false,
      detailShow: false,
      dimissionDilogShow: false,
      redactData: {},
      detailData: {},
      dimissionDilogData: {},
      tableLoading: false,
      tableParams: {
        carColor: 0,
        carNumber: "",
        carService: 0,
        limit: 10,
        page: 1,
        isPage: true
      },
      total: 0,
    };
  },
  components: {
    "v-search": search,
    "v-redact": redact,
    "v-detail": detail,
  },
  props: {},
  created () {
    this.getList();
  },
  methods: {
    getList (data) {
      this.tableParams.isPage = true;
      let params = data ? data : this.tableParams;
      this.tableLoading = true;
      this.$http.getCarMaintainList(params).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    // 事件处理函数
    async searchChange (value) {
      this.tableParams = value;
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    goRedact (row) {
      console.log(row);
      this.redactData = row;
      this.redactShow = true;
    },
    goDetail (row) {
      this.detailData = row;
      this.detailShow = true;
    },
    goDimission (row) {
      this.dimissionDilogData = row;
      this.dimissionDilogShow = true;
    },
    addFunction () {
      this.addStaffShow = true;
    },
    downloadExport () {
      this.tableParams.isPage = false;
      this.$http.getCarMaintainList(this.tableParams).then((res) => {
        if (res.code === 0) {
          const exportExcelList = res.data;
          // 表头
          const tHeader = [
            "序号",
            "车牌号码",
            "车牌颜色",
            "车辆营运性质",
            "技术等级有效期",
            "建议下次维养时间"
          ];
          // table表格中对应的属性名
          const filterVal = [
            "number",
            "carNumber",
            "carColorStr",
            "carServiceStr",
            "technicalGradeTime",
            "nextMaintainTime"
          ];
          exportExcel(tHeader, filterVal, exportExcelList, this.$route.name);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology.vue